import { createStore } from '@stencil/store';

// "subsection": "Mechanical Issues",
const initialState = {
  questions: [],
  questionsEngine: [],
  questionsTransmission: [],
  questionsSteering: [],
  questionsExhaust: [],
  questionsSuspension: [],
  questionsHeatingAir: [],
  questionsBatteryElectrical: [],
  questionsStereo: [],
  questionsOdometer: [],
  questionsSunMoonRoof: [],
  questionsAirbags: [],
  questionsFrameStructural: [],
  subSections: [
    'Engine',
    'Transmission',
    'Steering',
    'Exhaust',
    'Suspension',
    'Heating/Air Conditioning',
    'Battery/ Electrical',
    'Stereo',
    'Odometer',
    'Sunroof/ Moonroof',
    'Airbags',
    'Frame/ Structural',
  ],
  issueCount: 0,
  subIssueCounts: [] as Array<number>,
};

const { on, onChange, state, reset } = createStore(initialState);

export { on, onChange, state, reset };
export default state;
